"use client";

import styles from "./WelcomeOnPlatform.module.scss";
import { completeOnboarding } from "@vetty/api-sdk";
import { axiosInstance } from "@/helpers";
import { APP_ORIGIN } from "@/constants";
import { useEffect } from "react";
import { useLocale } from "@/i18n";
import { Flex } from "@vetty/ui";

/**
 * Final auth verification step. Marks onboarding complete, then returns the
 * user to the product app (APP_ORIGIN) — never an apps/app product onboarding route.
 */
export const WelcomeOnPlatform = () => {
  const locale = useLocale();

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        await completeOnboarding(axiosInstance);
      } catch {
        // Still attempt product return; account guard will re-prompt if needed.
      }
      if (cancelled) return;
      const base = APP_ORIGIN || "http://localhost:3001";
      window.location.assign(`${base.replace(/\/+$/, "")}/${locale}`);
    })();
    return () => {
      cancelled = true;
    };
  }, [locale]);

  return (
    <Flex
      className={styles["comp"]}
      direction={"column"}
      justify={"center"}
      gap={24}
    >
      <div className={styles["comp__image"]}>
        <img
          className={styles["comp__image__src"]}
          src="/assets/onboarding-welcome-on-platform.png"
          alt="Welcome on platform"
        />
      </div>
    </Flex>
  );
};
